import styled from 'styled-components';

import {breakpoint, colors} from 'theme';

export const BalanceCell = styled.div<{isNegative?: boolean}>`
    color: ${(p) => (p.isNegative ? colors.danger : colors.textPrimary)};
`;

export const CodesCountCell = styled.div`
    padding: 4px 8px;
    background-color: #f2f2ff;
    border-radius: 4px;
    font-size: 12px;
    color: #1a1a1a;
`;

export const GtinHeader = styled.div`
    display: flex;
    gap: 0.8rem;
    align-items: center;
`;

export const HeaderControls = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap-reverse;
    gap: 0.8rem;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: 20px;
    }
`;

export const NavigationWrapper = styled.div<{needMargin?: boolean}>`
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-width: 300px;

    @media (max-width: ${breakpoint.phone}) {
        margin-bottom: ${(p) => (p.needMargin ? '20px' : '0')};
    }
`;

export const ControlsWrapper = styled.div`
    @media (max-width: ${breakpoint.phone}) {
        flex-grow: 1;
    }
`;
